import AssetClient from "./assetClient";
import Helpers from "../../commons/helpers";

import { Constants } from "../../constants/constants";
import { IAssetInfo } from "../../commons/interfaces";

const AssetService = {
    async createUrlAsset(data: any) {
        const result = await AssetClient().post(Constants.ApiPath.ASSET.CREATE_URL_ASSET, data);
        return result.data.result;
    },

    async getAssetInfo(id: string): Promise<IAssetInfo> {
        const path = Helpers.handleUrlJoin(Constants.ApiPath.ASSET.GET_ASSET_INFO, id);
        const result = await AssetClient().get(path);
        return result.data.result;
    },

    async getMultiAssetInfo(data: { ids: string[] }): Promise<IAssetInfo[]> {
        const result = await AssetClient().post(Constants.ApiPath.ASSET.GET_MULTI_ASSET_INFO, data);
        return result.data.result;
    },

    async getExternalUrlIds(ids: string[]): Promise<{ id: string; url: string }[]> {
        const result = await AssetClient().post(Constants.ApiPath.ASSET.GET_EXTERNAL_URL_IDS, { ids });
        return result.data.result;
    },

    async setActiveById(id: string) {
        const result = await AssetClient().put(Constants.ApiPath.ASSET.SET_ACTIVE_BY_ID + `/${id}`);
        return result.data.result;
    },

    async getM3u8Url(id: string): Promise<string> {
        const result = await AssetClient().get(Constants.ApiPath.ASSET.GET_M3U8_URL + `/${id}`);
        return result.data.result;
    },

    async updateAssetResourceCode(request: { id: string; resourceCode: string }[]): Promise<string> {
        const result = await AssetClient().post(Constants.ApiPath.ASSET.UPDATE_RESOURCE_CODE, request);
        return result.data.result;
    },

    async getAssetSecret(id: string): Promise<string> {
        const result = await AssetClient().get(Constants.ApiPath.ASSET.GET_ASSET_SECRET + `/${id}`);
        return result.data.result;
    },
};

export default AssetService;
